module.exports = __webpack_public_path__ + "img/contact-info-row-red.89192000.png";